import DOM from '@common/DOM/DOM'

import Modal from './Modal'
import { EModalEvent } from './definitions'
import type { IModalProps } from './definitions'
import { getActModalId, increaseModalId } from './utils'

/**
 * Egy modal megjelenítése.
 * @param props - JSX property-k.
 */
export default function showModal (props: IModalProps): HTMLElement {
  let modal: HTMLElement

  const { callback, children, className, willRemove = true } = props

  const parent = props.parent ?? document.querySelector('#root') ?? document.body

  // ha már van modal és a clear false tehát hide után
  // nincs eltávolítva a DOM-ból, és a parent definiálva van.
  if (!willRemove && props.parent && parent.querySelector(`.sen-modal${ className ? `.${ className }` : '' }`)) {
    modal = parent.querySelector(`.sen-modal${ className ? `.${ className }` : '' }`) as HTMLElement

    increaseModalId()

    modal.setAttribute('id', getActModalId())

    // ha új tartalmat kap.
    if (children) {
      const content = modal.querySelector('.sen-modal__content') as HTMLElement

      content.innerHTML = ''
      content.appendChild(children)
    }

    // ha módosítani szeretnénk a már meglévő modalunkon/struktúráján.
    if (callback) {
      callback(modal)
    }
  }
  // ha új modalt kell létrehoznunk.
  else {
    const { children, ...rest } = props

    modal = (
      <Modal { ...rest }>
        { children ?? null }
      </Modal>
    )

    parent.appendChild(modal)
  }

  DOM.dispatch(modal, EModalEvent.Show)

  return modal
}
